import { useState, useEffect } from 'react';
import { DashboardList } from './DashboardList';

export function DashboardListProvider() {
  const [showList, setShowList] = useState(false);

  useEffect(() => {
    const handler = () => setShowList(true);
    window.addEventListener('dashboard:show-list', handler);
    return () => window.removeEventListener('dashboard:show-list', handler);
  }, []);

  if (!showList) return null;

  return <DashboardList onClose={() => setShowList(false)} />;
}